import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { selectPatentState, changeStatus, onSetSelectedPatent, onFetchPatents, onFetchTotalRows } from "../redux/slices/patentSlice"
import { patent } from "../types/slices/patentType"
import { PatentAPI } from "../apis/PatentAPI"
import { totalmem } from "os"

export const usePatentStore = () => {

    const dispatch = useDispatch()
    const { patents, patentSelected, status, action, totalRows } = useSelector(selectPatentState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getPatents = async (search = '', payload?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PatentAPI.getPatents({ search: search, ...payload })
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail, total } = response.data
            dispatch(onFetchPatents(detail))
            dispatch(onFetchTotalRows(total || 0))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedPatent = (patent: patent) => {
        try {
            dispatch(onSetSelectedPatent(patent))
        } catch (error) {
            console.log(error)
        }
    }

    const createPatent = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PatentAPI.create(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const updatePatent = async (id: number, data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PatentAPI.update(id, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deletePatent = async (id: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PatentAPI.delete(id)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    return {
        //states
        patents,
        patentSelected,
        status,
        action,
        totalRows,
        //actions
        getPatents,
        setSelectedPatent,
        createPatent,
        updatePatent,
        deletePatent
    }
}